import { render, staticRenderFns } from "./Obijime.vue?vue&type=template&id=0b64cb6f&"
import script from "./Obijime.vue?vue&type=script&lang=js&"
export * from "./Obijime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports